import { render } from "./WohngeldKZuschlagList.vue?vue&type=template&id=89a4918e"
import script from "./WohngeldKZuschlagList.vue?vue&type=script&lang=js"
export * from "./WohngeldKZuschlagList.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__